import fetch from '@/utils/fetch'
import {
  getUserPlaylistURI,
  addPlaylistURI,
  deletePlaylistURI,
  pubPlaylistURI,
  delPubPlaylistURI,
  getPlayLogsURI,
  delPlayVideosURI,
  updatePlayVideosURI,
  getVideosByPlidURI,
  insertOrUpdatePlayVideosURI,
} from './urls'

/**
 * 获取用户播单列表
 * @param params {
 *  id 播单主键id  n
 *  uuid 用户uuid y
 *  title 标题 n
 *  checkState 播单状态 n
 *  pageNo 页码
 *  pageSize 每页条数
 * }
 */
export function getUserPlaylist(params: any): Promise<any> {
  return fetch.get(getUserPlaylistURI, { params: params })
}

/**
 * 新增保存播单
 * @param data {
 *  tagCategory  标签分类
 *  coverImg1 封面图1
 *  coverImg2 封面图2
 *  coverImg3 封面图3
 *  title 标题
 *  subTitle 副标题
 *  tags 标签
 *  classId 频道分类id
 *  story 播单简介
 * }
 */
export function addPlaylist(data: any): Promise<any> {
  return fetch.post(addPlaylistURI, data)
}

/**
 * 删除播单
 * @param ids 需要删除的id用英文,号隔开
 */
export function deletePlaylist(ids: string): Promise<any> {
  return fetch.get(deletePlaylistURI, { params: { ids: ids } })
}

/**
 * 发布播单
 * @param id 播单主键id
 * }
 */
export function pubPlaylist(id: number): Promise<any> {
  return fetch.get(pubPlaylistURI, { params: { id: id } })
}

/**
 * 取消发布
 * @param ids 需要删除的id用英文,号隔开
 */
export function delPubPlaylist(ids: string): Promise<any> {
  return fetch.get(delPubPlaylistURI, { params: { ids: ids } })
}

/**
 * 查看不通过原因
 * @param id 播单主键id,
 * @param reasonType 类型 固定为1
 * }
 */
export function getPlayLogs(id: number, reasonType = 1): Promise<any> {
  return fetch.get(getPlayLogsURI, {
    params: { id: id, reasonType: reasonType },
  })
}

/**
 * 移除播单视频
 * @param data 播单主键id,
 *  [{
     "plId": 1,    //播单vrsId
     "videoId": 1, //视频vrsId
    }]
 * }
 */
export function delPlayVideos(data: any): Promise<any> {
  return fetch.post(delPlayVideosURI, data)
}

/**
 * 新增or更新播单视频
 * @param data 播单主键id,
 *  [{
     "plId": 1,    //播单vrsId
     "videoId": 1, //视频vrsId
     "sortNo": 1 //排序号
    }]
 * }
 */
export function updatePlayVideos(data: Array<object>): Promise<any> {
  return fetch.post(updatePlayVideosURI, data)
}

/**
 * 根据播单id获取关联视频:
 * @param id 播单主键id
 * }
 */
export function getVideosByPlid(id: number): Promise<any> {
  return fetch.get(getVideosByPlidURI, { params: { id: id } })
}
